import React from 'react';
import { TeamChat } from '../../components/chat/TeamChat';

// The CRM Employee Messages page is now powered by the shared TeamChat
// component (admin mode) so it stays byte-for-byte in sync with the
// Employee Portal Messages view.
export const CrmMessages = () => <TeamChat mode="admin" />;

export default CrmMessages;
